import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLifebooksNsps, getRightContentLessThanMin } from 'redux/selectors';
import { serviceIconPack } from 'helpers';
import { getNspTemplates } from 'services';
import {
	getServiceTemplateState,
	resolveNspId,
} from '../utils/servicePostUtils';
import ServiceAvatar from './ServiceAvatar';
import styles from '../editPost.module.css';

export default function ServiceOptions({
	state,
	setState,
	activeServiceCategoryIndex,
	setActiveServiceCategoryIndex,
}) {
	const nsps = useSelector(getLifebooksNsps);
	const lessThanMin = useSelector(getRightContentLessThanMin);

	useEffect(() => {
		let getTemplates = async () => {
			await getNspTemplates();
		};
		getTemplates();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const nspId = resolveNspId(state);
		if (nspId) {
			const serviceIndex = nsps.findIndex((val) => val.id === nspId);
			setActiveServiceCategoryIndex(serviceIndex);
		} else {
			setActiveServiceCategoryIndex(null);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [nsps, state.nsp, state.nspId]);

	const selectNsp = (val, index) => {
		setActiveServiceCategoryIndex(index);
		setState((currentState) =>
			getServiceTemplateState(val, currentState.change)
		);
	};

	const serviceMapper = (nsp, index) => {
		const { servicesCategory } = nsp;
		const ServiceIcon = serviceIconPack[servicesCategory];
		const isActive = activeServiceCategoryIndex === index;

		return (
			<div
				key={nsp.id}
				className={[
					styles.serviceOptionsTile,
					lessThanMin && styles.tileMin,
				].join(' ')}
				onClick={() => selectNsp(nsp, index)}>
				{!!ServiceIcon && (
					<ServiceAvatar isActive={isActive} alt={servicesCategory}>
						<ServiceIcon style={{ width: '40px', height: '40px' }} />
					</ServiceAvatar>
				)}
				<div
					className={[
						styles.serviceOptionsText,
						isActive && styles.activeText,
					].join(' ')}>
					{servicesCategory}
				</div>
			</div>
		);
	};

	return (
		<div className={styles.serviceOptionsTileContainer}>
			{nsps.map(serviceMapper)}
		</div>
	);
}
